import { EditorSelection, StateEffect, StateField } from "@codemirror/state";
import { EditorView } from "@codemirror/view";

import { hasEffect, updateHasEffect } from "./utils/effects.js";

export const selectionIntersects = (selection, extents) =>
    selection.ranges.some(
        (range) =>
            (extents.from <= range.from && extents.to >= range.from) ||
            (extents.from <= range.to && extents.to >= range.to),
    );

export const placeSelectionInsideBlock = (view, event) => {
    const line = view.lineBlockAtHeight(event.pageY - view.documentTop);
    const selectionRange = EditorSelection.cursor(line.to);
    const selection = event.ctrlKey ? view.state.selection.addRange(selectionRange) : selectionRange;

    return {
        selection,
        effects: EditorView.scrollIntoView(line.to),
    };
};

export const extendBackwardsOverEmptyLines = (doc, line, limit = Number.POSITIVE_INFINITY) => {
    let { number, from } = line;

    for (let lineNumber = number - 1; lineNumber > 0 && number - lineNumber <= limit; lineNumber -= 1) {
        const candidate = doc.line(lineNumber);
        if (candidate.text.trim().length > 0) {
            break;
        }
        from = candidate.from;
    }

    return from;
};

export const extendForwardsOverEmptyLines = (doc, line, limit = Number.POSITIVE_INFINITY) => {
    let { number, to } = line;

    for (let lineNumber = number + 1; lineNumber <= doc.lines && lineNumber - number <= limit; lineNumber += 1) {
        const candidate = doc.line(lineNumber);
        if (candidate.text.trim().length > 0) {
            break;
        }
        to = candidate.to;
    }

    return to;
};

export const mouseDownEffect = StateEffect.define();
export const hasMouseDownEffect = hasEffect(mouseDownEffect);
export const updateHasMouseDownEffect = updateHasEffect(mouseDownEffect);

const mouseDownListener = EditorView.domEventHandlers({
    mousedown(_event, view) {
        view.dispatch({
            effects: mouseDownEffect.of(true),
        });
    },
    mouseup(_event, view) {
        window.setTimeout(() => {
            view.dispatch({
                effects: mouseDownEffect.of(false),
            });
        });
    },
    contextmenu(_event, view) {
        window.setTimeout(() => {
            view.dispatch({
                effects: mouseDownEffect.of(false),
            });
        });
    },
    drop(_event, view) {
        window.setTimeout(() => {
            view.dispatch({
                effects: mouseDownEffect.of(false),
            });
        });
    },
});

const mousedownSelectionState = StateField.define({
    create() {
        return undefined;
    },
    update(value, transaction) {
        if (value && transaction.docChanged) {
            value = value.map(transaction.changes);
        }

        for (const effect of transaction.effects) {
            if (effect.is(mouseDownEffect)) {
                value = effect.value ? transaction.startState.selection : undefined;
            }
        }

        return value;
    },
});

export const getMousedownSelection = (state) => state.field(mousedownSelectionState);

export const mousedown = [mouseDownListener, mousedownSelectionState];
